import { configure } from "mobx";

configure({
  enforceActions: "never",
});

import app from "./app";
import balances from "./balances";
import currency from "./currency";
import market from "./market";
import trade from "./trade";
import cfdView from "./cfdView";
import user from "./user";

const store = {
  app,
  balances,
  currency,
  market,
  trade,
  cfdView,
  user,
};

export default store;
